import GameObject from '../GameObject/GameObject';
import TransformComponent from '../Component/Transform';

export function fit(
    gameObject: GameObject,
    width: number,
    height: number,
    maxScale: number = Infinity
): void {
    if(!gameObject.container) return;
    gameObject.addComponent(TransformComponent);
    const transform = gameObject.getComponent(TransformComponent);
    transform.width = transform.width || 1;
    transform.height = transform.height || 1;

    const scale = Math.min(
        maxScale,
        (width / transform.width) * transform.scale.x,
        (height / transform.height) * transform.scale.y
    );
    transform.scale.set(scale, scale);
}
